//Estados bancarios de CBU
export const EstadosBancarios = {
    Pendiente: 1,
    Aprobado: 2,
    Rechazado: 3,
    Borrado: 4,
};

export const getEstadoBancarioCbu = (estado) => {
    switch (Number(estado)) {
        case EstadosBancarios.Pendiente:
            return 'Pendiente';
        case EstadosBancarios.Aprobado:
            return 'Aprobado';
        case EstadosBancarios.Rechazado:
            return 'Rechazado';
        case EstadosBancarios.Borrado:
            return 'Borrado';
        default:
            return '-';
    }
};